import {
  ADD_EDGE,
  ADD_NODE,
  CHANGE_ACTIVE_NODE,
  UPDATE_DIALOG,
  CHANGE_GRAPH,
  REMOVE_EDGE,
  REMOVE_NODE,
  REQUEST_DIALOG,
  REQUEST_DIALOG_ERROR,
  REQUEST_DIALOG_SUCCESS,
  UPDATE_DIALOG_ERROR,
  UPDATE_DIALOG_SUCCESS,
  CHANGE_DIALOG_TO_CONFIGURE,
  REMOVE_DIALOG_SUCCESS,
  UPDATE_EDGE,
  UPDATE_FEATURE,
  UPDATE_NODE,
  LOAD_PHONENUMBERS,
  UPDATE_PHONENUMBER,
  CHANGE_PHONENUMBER_TO_CONFIGURE,
  RELINK_PHONENUMBER,
  RELINK_PHONENUMBER_SUCCESS,
  CHANGE_ACTIVE_DIALOG_ID,
  CHANGE_ACTIVE_DIALOG_REQUESTED,
  UNLINK_PHONENUMBER,
  UNLINK_PHONENUMBER_SUCCESS,
  REMOVE_DIALOG,
  ADD_DIALOG,
  LOAD_DIALOGS,
  FILTER_DIALOGS,
  FILTER_PHONENUMBERS,
  RELINK_PHONENUMBER_ERROR,
  CHANGE_DIALOG,
  RELOAD_DIALOGS,
  UPDATE_DIALOG_WARNING,
  REQUEST_VALIDATION_GRAPH,
  REQUEST_VALIDATION_GRAPH_SUCCESS,
  SET_PHONENUMBER_CHANGED,
} from '../actions';

export const changeActiveNode = (payload) => (
  {
    type: CHANGE_ACTIVE_NODE,
    payload,
  }
);

export const changeActiveDialogID = (payload) => (
  {
    type: CHANGE_ACTIVE_DIALOG_ID,
    payload,
  }
);

export const changeActiveDialogRequested = (payload) => (
  {
    type: CHANGE_ACTIVE_DIALOG_REQUESTED,
    payload,
  }
);

// region Dialog
export const loadDialogs = (payload) => (
  {
    type: LOAD_DIALOGS,
    payload,
  }
);

export const reloadDialogs = (payload) => (
  {
    type: RELOAD_DIALOGS,
    payload,
  }
);

export const filterDialogs = (payload) => (
  {
    type: FILTER_DIALOGS,
    payload,
  }
);

export const addDialog = (payload) => (
  {
    type: ADD_DIALOG,
    payload,
  }
);

export const updateDialog = ({
  dialogName, domainID, dialogID, containsPersonalData,
}) => ({
  type: UPDATE_DIALOG,
  payload: {
    dialogName, domainID, dialogID, containsPersonalData,
  },
});

export const updateDialogSuccess = (payload) => ({
  type: UPDATE_DIALOG_SUCCESS,
  payload,
});

export const updateDialogError = (payload) => ({
  type: UPDATE_DIALOG_ERROR,
  payload,
});

export const updateDialogWarning = (payload) => ({
  type: UPDATE_DIALOG_WARNING,
  payload,
});

export const removeDialog = (payload) => (
  {
    type: REMOVE_DIALOG,
    payload,
  }
);

export const removeDialogSuccess = (payload) => (
  {
    type: REMOVE_DIALOG_SUCCESS,
    payload,
  }
);

export const requestDialog = ({ domainID, dialogID, forceShowCurrent }) => ({
  type: REQUEST_DIALOG,
  payload: { domainID, dialogID, forceShowCurrent },
});

export const requestDialogSuccess = (payload) => ({
  type: REQUEST_DIALOG_SUCCESS,
  payload,
});

export const requestDialogError = (payload) => ({
  type: REQUEST_DIALOG_ERROR,
  payload,
});

export const changeDialogToConfigure = (payload) => ({
  type: CHANGE_DIALOG_TO_CONFIGURE,
  payload,
});

export const changeDialog = (payload) => ({
  type: CHANGE_DIALOG,
  payload,
});
// endregion

// region Graph
export const changeGraph = ({ dialogID, updatedGraph, nodePositionsChanged }) => (
  {
    type: CHANGE_GRAPH,
    payload: { dialogID, updatedGraph, nodePositionsChanged },
  }
);

export const addNode = ({ dialogID, newNode }) => (
  {
    type: ADD_NODE,
    payload: { dialogID, newNode },
  }
);

export const updateNode = ({ dialogID, updatedNode }) => (
  {
    type: UPDATE_NODE,
    payload: { dialogID, updatedNode },
  }
);

export const removeNode = ({ dialogID, nodeID }) => (
  {
    type: REMOVE_NODE,
    payload: { dialogID, nodeID },
  }
);

export const addEdge = ({ dialogID, newEdge }) => (
  {
    type: ADD_EDGE,
    payload: { dialogID, newEdge },
  }
);

export const updateEdge = ({ dialogID, updatedEdge }) => (
  {
    type: UPDATE_EDGE,
    payload: { dialogID, updatedEdge },
  }
);

export const removeEdge = ({ dialogID, edgeID }) => (
  {
    type: REMOVE_EDGE,
    payload: { dialogID, edgeID },
  }
);
// endregion

// region Feature
export const updateFeature = ({
  dialogID, featureID, updatedFeature, updateActiveNode = false,
}) => (
  {
    type: UPDATE_FEATURE,
    payload: {
      dialogID, featureID, updatedFeature, updateActiveNode,
    },
  }
);
// endregion

// region Phonenumber
export const loadPhonenumbers = (payload) => ({
  type: LOAD_PHONENUMBERS,
  payload,
});

export const filterPhonenumbers = (payload) => (
  {
    type: FILTER_PHONENUMBERS,
    payload,
  }
);

export const updatePhonenumber = (payload) => ({
  type: UPDATE_PHONENUMBER,
  payload,
});

export const setPhonenumberChanged = (payload) => ({
  type: SET_PHONENUMBER_CHANGED,
  payload,
});

export const changePhonenumberToConfigure = (payload) => ({
  type: CHANGE_PHONENUMBER_TO_CONFIGURE,
  payload,
});

export const relinkPhonenumber = (payload) => ({
  type: RELINK_PHONENUMBER,
  payload,
});

export const phonenumberRelinkSuccess = (payload) => ({
  type: RELINK_PHONENUMBER_SUCCESS,
  payload,
});

export const phonenumberRelinkError = (payload) => ({
  type: RELINK_PHONENUMBER_ERROR,
  payload,
});

export const unlinkPhonenumber = (payload) => ({
  type: UNLINK_PHONENUMBER,
  payload,
});

export const unlinkPhonenumberSuccess = (payload) => ({
  type: UNLINK_PHONENUMBER_SUCCESS,
  payload,
});
// endregion

// region Validation
export const requestValidationGraph = ({ dialogID }) => ({
  type: REQUEST_VALIDATION_GRAPH,
  payload: { dialogID },
});

export const requestValidationGraphSuccess = ({ dialogID, validationGraph }) => ({
  type: REQUEST_VALIDATION_GRAPH_SUCCESS,
  payload: { dialogID, validationGraph },
});
// endregion
